import type { Event, IdentifyEvent } from "@amplitude/analytics-browser/lib/esm/types"

import { UserAgent } from "@bounce/util"

import type { AmplitudeWebPlugin } from "../../types"

const IDENTIFY_EVENT: `${IdentifyEvent["event_type"]}` = "$identify"

const isIdentifyEvent = (event: Event): event is IdentifyEvent => {
  return event.event_type === IDENTIFY_EVENT
}

export const UserAgentIntegration: AmplitudeWebPlugin = {
  name: "User Agent",
  type: "before",

  execute: async event => {
    if (!isIdentifyEvent(event)) return event

    const parsedUA = UserAgent.get()
    if (parsedUA) {
      event.user_agent = parsedUA.ua
      event.user_properties = {
        ...event.user_properties,
        browser_name: parsedUA.browser.name,
        browser_version: parsedUA.browser.version,
        // Also adding this here because we were setting it here with Segment.
        user_agent: parsedUA.ua,
      }
    }

    return event
  },
}
